import moment from "moment";

export function GetTime(): any {}

export function GetDifffromNow(passTime: string): number {
  let timNow = moment();
  let timPass = moment(passTime);
  let timDiff = moment.duration(timNow.diff(timPass));
  return timDiff.asMilliseconds();
}

export function GetDifffromNowString(
  passTime: string,
  timeFormat: string
): string {
  let timNow = moment();
  let timPass = moment(passTime);
  let timDiff = moment.duration(timNow.diff(timPass));
  return formatTime(formatDuration(timDiff), timeFormat);
}

export function GetDateDifffromNowString(
  passTime: Date,
  timeFormat: string,
  timadd: number
): string {
  let timNow = moment();
  let timPass = moment(passTime);
  let timDiff = moment.duration(timNow.diff(timPass)).add(timadd, "seconds");
  return formatTime(formatDuration(timDiff), timeFormat);
}

export function GetDiff(firstTime: string, lastTime: string): string {
  const start = moment(firstTime, "HH:mm:ss");
  const end = moment(lastTime, "HH:mm:ss");
  const duration: moment.Duration = moment.duration(start.diff(end));
  let isNegative: boolean = false;
  let msSeconds = duration.asMilliseconds();
  if (duration.asMilliseconds() < 0) {
    isNegative = true;
    msSeconds = Math.abs(msSeconds);
  }
    return (isNegative ? "-" : "") + formatTime(moment.utc(msSeconds).format("HH:mm:ss.SS"), "S");
}

function formatDuration(duration: moment.Duration): string {
  const hours = Math.abs(duration.hours());
  const minutes = Math.abs(duration.minutes());
  const seconds = Math.abs(duration.seconds());
  const Msseconds = Math.abs(duration.milliseconds());

  // Formatting the time to ensure they have two digits
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");
  const formattedMSSeconds = Msseconds.toString().padStart(2, "0");

  // const isNegative: boolean = duration.asMilliseconds() < 0;
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}.${formattedMSSeconds}`;
}

export function formatDateTime(datetime: Date, timeFormat: string): string {
  const formattedDate = moment(datetime).format("HH:mm:ss.SSS");

  // let tim:string[] =  datetime.split("T");
  // if (tim.length > 1)
  // {
  return formatTime(formattedDate, timeFormat);
}

export function formatTime(time: string, timeFormat: string): string {
  if (time == null) {
    return time;
  }

  if (time[0] === "D") {
    return time;
  }
  let tString = time.split(".");
  let Poi = -1; // Indicates the position from which we'll take the substring
  for (let i = 0; i < tString[0].length; i++) {
    Poi = i;
    if (
      !(tString[0][i] === "0" || tString[0][i] === ":" || tString[0][i] === "-")
    ) {
      break;
    }
  }
  let Ar2 = time.substring(Poi).split(".");
  let Tim = Ar2[0];
  if (timeFormat === "S") {
    return Tim;
  } else if (timeFormat === "T") {
    return Ar2.length < 2 ? Tim + ".0" : Tim + "." + Ar2[1][0];
  } else if (timeFormat === "H") {
    if (Ar2.length < 2) {
      return Tim + ".00";
    } else {
      return Ar2[1].length < 2
        ? Tim + "." + Ar2[1][0] + "0"
        : Tim + "." + Ar2[1][0] + Ar2[1][1];
    }
  }
  return Tim;
}
